var _rect, _path, _rect2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaggage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8617 4.9221H13.4795V2.70523C13.4795 2.35781 13.1978 2.07617 12.8504 2.07617H7.14956C6.80214 2.07617 6.5205 2.35781 6.5205 2.70523V4.9221H2.13832C0.959256 4.9221 0 5.88136 0 7.06038V15.7845C0 16.9635 0.959256 17.9227 2.13832 17.9227H17.8617C19.0407 17.9227 20 16.9635 20 15.7845V7.06038C20 5.88136 19.0407 4.9221 17.8617 4.9221ZM7.77862 3.33433H12.2213V4.92214H7.77862V3.33433ZM3.47867 16.6647H2.13832C1.65297 16.6647 1.25812 16.2698 1.25812 15.7845V7.06038C1.25812 6.57507 1.65297 6.18023 2.13832 6.18023H3.47867V16.6647ZM15.2631 16.6647H4.73683V6.18023H15.2632V16.6647H15.2631ZM18.7418 15.7845C18.7418 16.2698 18.347 16.6647 17.8616 16.6647H16.5213V6.18023H17.8616C18.347 6.18023 18.7418 6.57507 18.7418 7.06038V15.7845Z",
    fill: "#666969"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 1,
    width: 7,
    height: 7,
    rx: 3.5,
    fill: "#666969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3L16.5 6M15 4.5H18",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaggage);
export default __webpack_public_path__ + "static/media/baggage.d400cecfd1092f6aca7a014bc77454ae.svg";
export { ForwardRef as ReactComponent };